import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var DownloadAllegatoCtrl = function (fn, er, state, token, ids) {
	var config = {
		headers: {
			'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},
		responseType: 'blob'
	};

	var data = {
		doc: state.doc,
		path: state.path
	};

	axios
		.post(ApiConfig.url.EBOX_DOWNLOAD_ALLEGATO, data, config)
		.then(function (result) {
			fn(result.data, result.status)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { DownloadAllegatoCtrl };